(ns common.schema.entities.graph-reference
  (:require [common.schema.schema-utils :as su]))

;; For new graph-reference-types:
;; -also add localizations (for :key)
;; -also add export definitions (in ui.view.entity-graph.export)
(def type-defs
  [{:key :graph-reference.type/ownership
    :label "Ownership"
    :connector? true
    :default
    {:source-handle :bottom
     :target-handle :left
     :line-type :solid}
    :relationship-list-label
    {:source "Owner in"
     :target "Owned by"}
    :create-label
    {:source "Add ownership in"
     :target "Add owner"}
    :allowed-entity-types
    {:source #{:entity.type/company
               :entity.type/fof-asset
               :entity.type/fund
               :entity.type/person}
     :target #{:entity.type/company}}
    :metadata #{:graph-meta/ownership-percentage}}
   {:key :graph-reference.type/lp
    :label "LP"
    :connector? true
    :default
    {:source-handle :right
     :target-handle :top
     :line-type :solid}
    :relationship-list-label
    {:source "LP in"
     :target "LPs"}
    :create-label
    {:source "Set as LP in"
     :target "Add LP"}
    :allowed-entity-types
    {:source #{:entity.type/company :entity.type/person}
     :target #{:entity.type/fof-asset :entity.type/fund}}}
   {:key :graph-reference.type/gp
    :label "GP"
    :connector? true
    :default
    {:source-handle :right
     :target-handle :top
     :line-type :solid}
    :relationship-list-label
    {:source "GP in"
     :target "GP"}
    :create-label
    {:source "Set as GP of"
     :target "Add GP"}
    :allowed-entity-types
    {:source #{:entity.type/company}
     :target #{:entity.type/fof-asset
               :entity.type/fund}}}
   {:key :graph-reference.type/management-company
    :label "ManCo"
    :connector? true
    :default
    {:source-handle :bottom
     :target-handle :top
     :line-type :solid}
    :relationship-list-label
    {:source "Management company of"
     :target "Management company"}
    :create-label
    {:source "Set as management company of"
     :target "Add a management company"}
    :allowed-entity-types
    {:source #{:entity.type/company}
     :target #{:entity.type/fof-asset
               :entity.type/fund}}}
   {:key :graph-reference.type/aifm
    :label "AIFM"
    :connector? true
    :default
    {:source-handle :right
     :target-handle :top
     :line-type :solid}
    :relationship-list-label
    {:source "AIFM of"
     :target "AIFM"}
    :create-label
    {:source "Set as AIFM of"
     :target "Add AIFM"}
    :allowed-entity-types
    {:source #{:entity.type/company}
     :target #{:entity.type/company
               :entity.type/fof-asset
               :entity.type/fund}}}
   {:key :graph-reference.type/advisor
    :label "Advisor"
    :connector? true
    :default
    {:source-handle :right
     :target-handle :top
     :line-type :solid}
    :relationship-list-label
    {:source "Advisor of"
     :target "Advisors"}
    :create-label
    {:source "Set as an advisor of"
     :target "Add an advisor"}
    :allowed-entity-types
    {:source #{:entity.type/company}
     :target #{:entity.type/company}}}
   ;; Non-connectors (for now), only for table-view/graph-entity-curtain:
   {:key :graph-reference.type/executive
    :label "Executive"
    :relationship-list-label
    {:source "Executive in"
     :target "Executives"}
    :allowed-entity-types
    {:source #{:entity.type/person}
     :target #{:entity.type/company}}
    :metadata #{:graph-meta/executive-role}}
   {:key :graph-reference.type/board-member
    :label "Board member"
    :relationship-list-label
    {:source "Board member in"
     :target "Board members"}
    :allowed-entity-types
    {:source #{:entity.type/person}
     :target #{:entity.type/company}}
    :metadata #{:graph-meta/board-member-role}}
   {:key :graph-reference.type/auditor
    :label "Auditor"
    :relationship-list-label
    {:source "Auditor in"
     :target "Auditors"}
    :allowed-entity-types
    {:source #{:entity.type/person}
     :target #{:entity.type/company}}
    :metadata #{:graph-meta/auditor-role}}
   {:key :graph-reference.type/auditing-firm
    :label "Auditing firm"
    :relationship-list-label
    {:source "Auditing firm in"
     :target "Auditing firms"}
    :allowed-entity-types
    {:source #{:entity.type/company}
     :target #{:entity.type/company}}}
   ;;later:
   #_{:key :graph-reference.type/ubo
      :label "UBO"}])

(def type-options
  (->> type-defs
       (mapv (fn [type-def]
               (select-keys type-def [:key :label])))))

(def labels
  (->> type-options
       (mapv (fn [{:keys [key label]}]
               [key label]))
       (into {})))

(def ordered-connector-types
  (->> type-defs
       (filterv :connector?)
       (mapv :key)))

;; "Connector": a visual representation of a graph-reference i.e. an edge
;; that can be drawn on the entity-graph:
(def connector-types
  (->> ordered-connector-types
       (into #{})))

(def relationship-list-label
  (->> type-defs
       (mapv (fn [{:keys [key relationship-list-label]}]
               [key relationship-list-label]))
       (into {})))

(def create-gref-label
  (->> type-defs
       (mapv (fn [{:keys [key create-label]}]
               [key create-label]))
       (filterv (fn [[_k create-label]]
                  (seq create-label)))
       (into {})))

;; which entity-types are allowed for a graph-ref-type based on direction
(def allowed-entity-types
  (->> type-defs
       (mapv (fn [{:keys [key allowed-entity-types]}]
               [key allowed-entity-types]))
       (into {})))
;;e.g.
;; :graph-reference.type/lp {:source #{:entity.type/company :entity.type/person}
;;                           :target #{:entity.type/fof-asset :entity.type/fund}}
;;example usage: (get-in allowed-entity-types [graph-ref-type :target])

;; other way i.e. given an entity-type and graph-ref-type, which direction
;; (target/source) are allowed
;; e.g. company can be a source of lp-reference (but not target)
;; (get-in types-by-entity-type [:entity.type/company :graph-reference.type/lp])
;;  => #{:source}
(def types-by-entity-type
  (->> allowed-entity-types
       (reduce (fn [res [type dir-ets]]
                 (->> dir-ets
                      (reduce (fn [inner [dir ets]]
                                (->> ets
                                     (reduce (fn [inner et]
                                               (update-in inner
                                                          [et type]
                                                          (fnil conj #{}) dir))
                                             inner)))
                              res)))
               {})))

(def connectors-by-entity-type
  (->> types-by-entity-type
       (mapv (fn [[et gref-defs]]
               [et (select-keys gref-defs connector-types)]))
       (filter (fn [[_entity-type connector-defs]]
                 (seq connector-defs)))
       (into {})))

(def graph-references-metadata
  (->> type-defs
       (filterv :metadata)
       (mapv (fn [{:keys [key metadata]}]
               [key metadata]))
       (into {})))

(def schema
  (concat
   [[:graph-reference/type
     {:field/data-type :data.type/keyword
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/system}
      :field/system-required? true
      :field/system-semantics su/system-controlled-required-field-semantics
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :in-use-disabled}
      :options type-options
      :field/hidden-from-configuration? true
      :field/translations {:en "Type"}}]
    [:graph-reference/source
     {:field/data-type :data.type/ref-single
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/system}
      :field/system-required? true
      :field/system-semantics su/system-controlled-required-field-semantics
      :field/default-visibility {:editor :editor.type/link
                                 :grid   :editor.type/link
                                 :filter :filter.type/select
                                 :field-visibility :in-use-disabled}
      :field/entity-types [:entity.type/graph-entity]
      :field/hidden-from-configuration? true
      :field/translations {:en "Source"}}]
    [:graph-reference/target
     {:field/data-type :data.type/ref-single
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/system}
      :field/system-required? true
      :field/system-semantics su/system-controlled-required-field-semantics
      :field/default-visibility {:editor :editor.type/link
                                 :grid   :editor.type/link
                                 :filter :filter.type/select
                                 :field-visibility :in-use-disabled}
      :field/entity-types [:entity.type/graph-entity]
      :field/hidden-from-configuration? true
      :field/translations {:en "Target"}}]
    [:graph-reference/metadata
     {:field/data-type :data.type/ref-multi
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/user}
      :field/default-visibility {:editor :editor.type/link
                                 :grid   :editor.type/link
                                 :filter :filter.type/select
                                 :field-visibility :in-use-disabled}
      :field/entity-types [:entity.type/graph-meta]
      :field/hidden-from-configuration? true
      :field/translations {:en "Connection data"}}]]))
